if (!customElements.get('okendo-reviews')) {
  customElements.define(
    'okendo-reviews',
    class extends HTMLElement {
      constructor() {
        super()
      }

      async updateReviews() {
        let url = `${window.location.pathname}?section_id=${this.sectionId}`
        if (!url.includes('/products/')) {
          const productInfo = document.querySelector('product-info')
          if (productInfo) {
            url = `${productInfo.dataset.url}?section_id=${this.sectionId}`
          }
        }
        try {
          const response = await fetch(url)
          const htmlSection = await response.text()
          const html = new DOMParser().parseFromString(htmlSection, 'text/html')
          const newElement = html.querySelector('okendo-reviews')
          if (newElement) {
            HTMLUpdateUtility.viewTransition(this, newElement, []) // This class is defined in liquid-pdp.js
          }
          const widgetElement = document.querySelector('[data-oke-widget]')
          if (widgetElement) {
            window.okeWidgetApi.initWidget(widgetElement)
          }
        } catch (e) {
          console.error(e)
        }
      }

      // Set reviews for selected productID
      async renderProductReviews(productId) {
        const widgetElement = this.querySelector('[data-oke-widget]')
        if (productId && widgetElement && window.okeWidgetApi) {
          try {
            const setProduct = await window.okeWidgetApi.setProduct(
              widgetElement,
              `shopify-${productId}`,
            )
          } catch (e) {
            console.error('Error initializing Okendo widget:', e)
          }
        }
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section
      }
    },
  )
}
